import { forwardRef, type HTMLAttributes } from "react";
import { cn } from "src/utils/Functions";

const rootStyles =
  "p-1 rounded-2xl bg-background dark:bg-neutral-100/5 border border-border dark:border-border/60 flex flex-col shadow-xs overflow-hidden";

const headerStyles = "flex items-center justify-between min-h-10.5 p-2";

const contentWrapperStyles =
  "p-2 flex-1 flex flex-col bg-neutral-100 dark:bg-neutral-400/5 rounded-2xl";

export const SectionCardRoot = forwardRef<
  HTMLDivElement,
  HTMLAttributes<HTMLDivElement>
>(function SectionCardRoot({ className, ...props }, ref) {
  return (
    <div
      ref={ref}
      className={cn(rootStyles, className)}
      {...props}
    />
  );
});

export function SectionCardHeader({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return <div className={cn(headerStyles, className)} {...props} />;
}

export function SectionCardContent({
  className,
  ...props
}: HTMLAttributes<HTMLDivElement>) {
  return (
    <div className={contentWrapperStyles}>
      <div className={cn("flex flex-col", className)} {...props} />
    </div>
  );
}

export const SectionCard = Object.assign(SectionCardRoot, {
  Header: SectionCardHeader,
  Content: SectionCardContent,
});
